<div [formGroup]="formGroup" class="w-full py-1 px-2">
  <!-- LABEL ABOVE -->
  <div *ngIf="labelAbove; else sideLabelLayout">
    <label
      class="block text-2sm font-semibold text-gray-700 dark:text-gray-300 mb-1"
    >
      {{ fields.displayName }}
      <span *ngIf="fields.isRequired" class="text-danger">*</span>
    </label>

    <ng-container *ngTemplateOutlet="phoneInputBlock"></ng-container>
  </div>

  <!-- SIDE LABEL -->
  <ng-template #sideLabelLayout>
    <div class="grid grid-cols-12 gap-3 rounded-lg w-full items-center">
      <div class="col-span-4">
        <label
          class="block text-2sm font-semibold text-gray-700 dark:text-gray-300 whitespace-normal break-words leading-tight"
        >
          {{ fields.displayName }}
          <span *ngIf="fields.isRequired" class="text-danger">*</span>
        </label>
      </div>

      <div class="col-span-8">
        <ng-container *ngTemplateOutlet="phoneInputBlock"></ng-container>
      </div>
    </div>
  </ng-template>

  <!-- PHONE INPUT TEMPLATE -->
  <ng-template #phoneInputBlock>
    <div class="relative w-full">
      <div
        class="phone-input-container"
        [class.has-error]="formGroup.get(fields.fieldName)?.touched && formGroup.get(fields.fieldName)?.invalid"
      >
        <!-- Selected Code -->
        <button
          type="button"
          (click)="toggleDropdown(fields.fieldName, $event)"
          class="phone-dial-btn"
          [attr.aria-expanded]="dropdownOpen === fields.fieldName"
          aria-haspopup="listbox"
        >
          <span class="min-w-0 truncate">
            {{
              selectedCodes[fields.fieldName] || countryResponse[0]?.dial_code
            }}
          </span>
          <svg
            class="h-4 w-4 shrink-0 text-gray-500 dark:text-gray-300"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 9l-7 7-7-7"
            ></path>
          </svg>
        </button>

        <!-- Phone Number Input -->
        <input
          type="tel"
          [formControlName]="fields.fieldName"
          [placeholder]="fields.placeholder"
          (input)="onKeyUpValidateFields(fields)"
          [id]="fields.fieldName"
          class="phone-number-field"
        />
      </div>

      <!-- Dropdown List Above -->
      <div
        *ngIf="dropdownOpen === fields.fieldName"
        [ngStyle]="dropdownStyle"
        class="max-h-48 overflow-y-auto rounded border border-gray-300 bg-white shadow-lg dark:bg-coal-600"
      >
        <div
          *ngFor="let option of countryResponse"
          (click)="onCodeChange(option.dial_code, fields.fieldName)"
          class="cursor-pointer px-3 py-2 text-sm text-gray-800 transition-colors dark:text-gray-200"
          role="option"
        >
          {{ option.iso2 }} ({{ option.dial_code }})
        </div>
      </div>
    </div>
    <!-- Validation -->
    <div
      *ngIf="
        formGroup.get(fields.fieldName)?.touched &&
        formGroup.get(fields.fieldName)?.invalid
      "
      class="text-danger text-sm mt-1"
    >
      <div *ngIf="formGroup.get(fields.fieldName)?.errors?.['required']">
        Please enter {{ fields.displayName }}
      </div>
      {{ errors[fields.fieldName] }}
    </div>
  </ng-template>
</div>
